import client from './client'

export default {
  getAllJourneys () {
    return client.withAuth().get('womapi/api/home')
  },
  createJourney (params) {
    return client.withAuth().post('womapi/api/output/journey/create', params)
  },
  editJourney (params) {
    return client.withAuth().post('womapi/api/output/journey/edit', params)
  },
  getJourney (params) {
    return client.withAuth().get('womapi/api/output/journey', params)
  },
  deleteJourney (params) {
    // return client.withAuth().delete('womapi/api/output/journey', params, {}, { 'Accept': 'text/html' }, {})
    return client.withAuth().post('womapi/api/output/journey/delete', params, {}, { 'Accept': 'text/html' }, {})
  }
}
